import { addCollection } from '@iconify/react'
import lucideIcons from '@iconify-json/lucide/icons.json'

export const RegisterOfflineIcon = () => {
  addCollection(lucideIcons)

  return <></>
}
